import React, { useContext, useState } from 'react';
import japyIcon from "../../../assets/openFresa.png";
import { 
  CropIcon, 
  PhenologicalStageIcon, 
  CultivationEnvironmentIcon, 
  HydroponicSystemTypeIcon,
  SoilTypeIcon 
} from "../../Common/CustomIcons/CustomIcons";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Avatar,
  Paper,
  TextField,
  IconButton,
  InputAdornment,
  Button,
  Fade,
  Slide,
} from '@material-ui/core';
import {
  makeStyles
} from '@material-ui/core/styles';
import {
  DateRange,
} from '@material-ui/icons';
import { CancelOutlined, ImageSearchOutlined, PhotoCameraOutlined } from '@material-ui/icons';
import { UserContext } from '../../../context/UserProvider';
import { MultiCropContext } from '../../../context/MultiCropContext/MultiCropContext';
import { SelectSensors } from '../ChatBotForm/SelectSensors';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { HistoricalChatsPanel } from './HistoricalChatsPanel';
import { CameraImages } from './CameraImages';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  mainContainer: {
    maxWidth: 1200,
    margin: '0 auto',
  },
  headerCard: {
    background: 'white',
    borderRadius: 10,
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    marginBottom: theme.spacing(3),
    overflow: 'visible',
  },
  cropSelector: {
    minWidth: 250,
    '& .MuiOutlinedInput-root': {
      borderRadius: 10,
      background: 'white',
      '&:hover': {
        background: '#f8f9fa',
      },
    },
  },
  cropInfoCard: {
    background: '#FFFFFF',
    color: '#333333',
    borderRadius: 10,
    marginTop: theme.spacing(2),
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e0e0e0',
  },
  sensorSection: {
    marginTop: theme.spacing(3),
  },
  sensorCard: {
    borderRadius: 10,
    background: '#FFFFFF',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e0e0e0',
  },
  chatContainer: {
    background: 'white',
    borderRadius: 10,
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    marginTop: theme.spacing(3),
  },
  chatHeader: {
    background: theme.palette.primary.main,
    color: 'white',
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  chatMessages: {
    height: 400,
    overflowY: 'auto',
    padding: theme.spacing(2),
    background: '#f8f9fa',
  },
  messageBot: {
    background: '#e3f2fd',
    borderRadius: '15px 15px 15px 4px',
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    maxWidth: '80%',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  messageUser: {
    background: theme.palette.primary.main,
    color: 'white',
    borderRadius: '15px 15px 4px 15px',
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    maxWidth: '80%',
    marginLeft: 'auto',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  chatInput: {
    padding: theme.spacing(2),
    background: 'white',
    borderTop: '1px solid #e0e0e0',
  },
  inputField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 10,
      background: '#f8f9fa',
      '&:hover': {
        background: '#f0f0f0',
      },
      '&.Mui-focused': {
        background: 'white',
      },
    },
  },
  analyzeButton: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: 10,
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: 600,
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      backgroundColor: '#4a9029',
    },
  },
  iconAvatar: {
    // backgroundColor: theme.palette.primary.main,
    width: 60,
    height: 60,
  },
  expandButton: {
    transition: 'transform 0.3s ease',
  },
  expandButtonRotated: {
    transform: 'rotate(180deg)',
  },
  infoChip: {
    margin: theme.spacing(0.5),
    background: theme.palette.primary.main,
    color: 'white',
    '& .MuiChip-icon': {
      color: 'white',
    },
  },
  input: {
    display: 'none',
  },
  input_IC: {
    display: 'none',
  },
  formControl: {
    margin: theme.spacing(1),
    position: 'relative',
    width: '50%',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

export const ChatbotJapy = () => {
  const classes = useStyles();
  const { usuario, userTimezone } = useContext(UserContext);
  const {
    namesOfCrops,
    crops,
    weeksOfCrops,
    daysOfCrops,
    placeOfCrops,
    variantsOfCrop,
    phenoStages,
    indoorSystems,
    soilTypes,
    currentCoordinates,
  } = useContext(MultiCropContext);

  const [cropSelected, setCropSelected] = useState(0);
  const [messages, setMessages] = useState([
    {
      type: 'bot',
      content: '¡Hola! Soy Japy, tu asistente de agricultura inteligente. Selecciona un cultivo y sus sensores para comenzar el análisis.',
      timestamp: new Date(),
    },
  ]);
  const [newMessage, setNewMessage] = useState('');
  const [loadingAnalysis, setLoadingAnalysis] = useState(false);
  const [synchronized, setSynchronized] = useState(false);
  const [isNewChat, setIsNewChat] = useState('yes');
  const [titleForChat, setTitleForChat] = useState('Nuevo Chat');
  const [typeOfResponse, setTypeOfResponse] = useState('PyT');

  // Imagenes
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [secondImageUrl, setSecondImageUrl] = useState('');
  const [imageFlag, setImageFlag] = useState(false);
  // Nota: ya no se usa imageName

  const weekAndDay = `Semana ${weeksOfCrops[cropSelected]} y Día ${daysOfCrops[cropSelected]}`;
  const envCrop = placeOfCrops[cropSelected] === "Exterior" ? soilTypes[cropSelected] : indoorSystems[cropSelected];

  // Endpoints
  const testingChatJapy = process.env.REACT_APP_TEST_ASK_JAPY;
  const resizeImageUrl = process.env.REACT_APP_RESIZE_IMAGE;
  const getChatHistory = process.env.REACT_APP_GET_CHAT_HISTORY


  const handleChangeCrop = (event) => {
    setCropSelected(event.target.value);
    setSynchronized(false);
    setIsNewChat('yes');
    setTitleForChat('Nuevo Chat');
    setImage(null);
    setImageUrl('');
    setSecondImageUrl('');
    setImageFlag(false);
    setNewMessage('');
    // Agregar mensaje del bot sobre el cambio de cultivo
    const botMessage = {
      type: 'bot',
      content: `Has seleccionado el cultivo: ${namesOfCrops[event.target.value]}. Ahora puedes configurar los sensores y realizar un análisis.`,
      timestamp: new Date(),
    };
    setMessages(prev => [...prev, botMessage]);
  };

  // Subir imagen (resize)
  const uploadImage = async () => {
    const formData = new FormData();
    formData.append('username', usuario.username);
    if (image) {
      formData.append('file', image);
      formData.append('id', image.name);
    } else {
      formData.append('id', 'none');
    }
    const response = await fetch(resizeImageUrl, {
      method: 'POST',
      body: formData,
    });
    if (!response.ok) throw new Error('Error en la solicitud de imagen');
    return response.text();
  };

  const continueChat = async (chatTitle) => {
    setTitleForChat(chatTitle);
    setIsNewChat('no');
    
    try {
      // Hacer petición para obtener el historial del chat
      const response = await fetch(getChatHistory, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: usuario.username,
          chatName: chatTitle
        }),
      });
      
      if (!response.ok) {
        throw new Error('Error al cargar el historial del chat');
      }
      
      const chatHistory = await response.json();
      
      // Convertir el historial a mensajes del chat
      const historyMessages = chatHistory.map((message, index) => ({
        type: message.role === 'assistant' ? 'bot' : 'user',
        content: message.content,
        timestamp: new Date(), // Usar fecha actual ya que no tenemos timestamp del historial
      }));
      
      // Agregar mensaje de confirmación al final
      const confirmationMessage = {
        type: 'bot',
        content: `Se cargó el historial del chat: ${chatTitle}. Puedes continuar la conversación.`,
        timestamp: new Date(),
      };
      
      // Establecer todos los mensajes del historial más el mensaje de confirmación
      setMessages([...historyMessages, confirmationMessage]);
      
    } catch (error) {
      console.error('Error al cargar el historial:', error);
      // En caso de error, mostrar mensaje de error
      setMessages(prev => ([...prev, {
        type: 'bot',
        content: `Error al cargar el historial del chat: ${chatTitle}. ${error.message}`,
        timestamp: new Date(),
      }]));
    }
  };

  const sendApiRequest = async ({ isInitial }) => {
    const payload = isInitial
      ? {
          crop: crops[cropSelected],
          cultivation_stage: phenoStages[cropSelected],
          cultivation_location: placeOfCrops[cropSelected],
          username: usuario.username,
          newChat: 'yes',
          imageUploaded: imageFlag ? 'yes' : 'no',
          coordinates: currentCoordinates[cropSelected],
          timezone: userTimezone,
          responseMode: typeOfResponse,
          weekStage: weekAndDay,
          envCrop: envCrop,
          message: newMessage,
        }
      : {
          newChat: 'no',
          username: usuario.username,
          message: newMessage,
          imageUploaded: imageFlag ? 'yes' : 'no',
          chatTitle: titleForChat,
          responseMode: typeOfResponse,
        };

    if (image && imageFlag) {
      try {
        await uploadImage();
      } catch (e) {
        // continuar sin imagen
        // console.error(e);
      } finally {
        setImageFlag(false);
      }
    }

    const response = await fetch(testingChatJapy, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error('Error en la solicitud');
    const responseData = await response.json();
    return responseData;
  };

  const handleSendMessage = async () => {
    if (newMessage.trim() === '') return;

    const userMessage = {
      type: 'user',
      content: newMessage,
      timestamp: new Date(),
    };

    setMessages(prev => [...prev, userMessage]);
    setLoadingAnalysis(true);
    try {
      const responseData = await sendApiRequest({ isInitial: false });
      const botResponse = {
        type: 'bot',
        content: `¡Hola! Japy te ayuda:\n\n${responseData.respuesta}`,
        timestamp: new Date(),
      };
      setMessages(prev => [...prev, botResponse]);
      setTitleForChat(prev => (prev === 'Nuevo Chat' ? (responseData.titulo || prev) : prev));
      setIsNewChat('no');
      setNewMessage('');
      setSecondImageUrl('');
      setImage(null);
      setImageFlag(false);
    } catch (error) {
      const botError = {
        type: 'bot',
        content: 'Ocurrió un error al procesar tu mensaje.',
        timestamp: new Date(),
      };
      setMessages(prev => [...prev, botError]);
    }
    setLoadingAnalysis(false);
  };

  const handleAnalyzeCrop = async () => {
    if (!synchronized) {
      const errorMessage = {
        type: 'bot',
        content: 'Por favor, primero sincroniza los sensores antes de realizar el análisis.',
        timestamp: new Date(),
      };
      setMessages(prev => [...prev, errorMessage]);
      return;
    }

    setLoadingAnalysis(true);

    const analysisMessage = {
      type: 'user',
      content: `Solicitar análisis del cultivo: ${namesOfCrops[cropSelected]}`,
      timestamp: new Date(),
    };

    setMessages(prev => [...prev, analysisMessage]);
    try {
      const responseData = await sendApiRequest({ isInitial: true });
      const botResponse = {
        type: 'bot',
        content: `¡Hola! Soy Japy, tu experto cultivador virtual y este es el resultado de mi análisis:\n\n${responseData.respuesta}\n\n¿Te puedo ayudar en algo más Gappier?`,
        timestamp: new Date(),
      };
      setMessages(prev => [...prev, botResponse]);
      setTitleForChat(responseData.titulo || 'Nuevo Chat');
      setIsNewChat('no');
      setSynchronized(false);
      setImage(null);
      setImageUrl('');
      setSecondImageUrl('');
      setNewMessage('');
      setImageFlag(false);
    } catch (error) {
      const botError = {
        type: 'bot',
        content: 'Ocurrió un error al iniciar el análisis.',
        timestamp: new Date(),
      };
      setMessages(prev => [...prev, botError]);
    }
    setLoadingAnalysis(false);
  };

  const handlePrimaryAction = async () => {
    if (isNewChat === 'yes') {
      await handleAnalyzeCrop();
    } else {
      await handleSendMessage();
    }
  };

  return (
    <Box className={classes.root}>
        <Box className={classes.mainContainer}>
          {/* Header con selector de cultivo */}
          <Fade in timeout={800}>
            <Card className={classes.headerCard}>
              <CardContent>
                <Grid container spacing={3} alignItems="center">
                  <Grid item>
                    <Avatar className={classes.iconAvatar}>
                      <img style={{width: '100%'}} src={japyIcon} alt="Japy Icon" />
                    </Avatar>
                  </Grid>
                  <Grid item xs>
                    <Typography variant="h5" gutterBottom>
                      Japy - Asistente de Agricultura Inteligente
                    </Typography>
                    <Typography variant="body1" color="textSecondary">
                      Analiza tus cultivos con inteligencia artificial
                    </Typography>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined" className={classes.cropSelector}>
                      <InputLabel>Seleccionar Cultivo</InputLabel>
                      <Select
                        value={cropSelected}
                        onChange={handleChangeCrop}
                        label="Seleccionar Cultivo"
                        // startAdornment={
                        //   <InputAdornment position="start">
                        //     <Agriculture color="primary" />
                        //   </InputAdornment>
                        // }
                      >
                        {namesOfCrops.map((item, index) => (
                          <MenuItem value={index} key={index}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Fade>

          {/* Información del cultivo */}
          <Slide direction="up" in timeout={1000}>
            <Card className={classes.cropInfoCard}>
              <CardContent>
                <Grid container alignItems="center" justifyContent="space-between">
                  <Grid item>
                    <Typography variant="h6" gutterBottom style={{ color: '#333333' }}>
                      Información del Cultivo
                    </Typography>
                  </Grid>
                </Grid>

                <Box>
                  <Grid container spacing={2} style={{ marginTop: 8 }}>
                    <Grid item xs={12} sm={6} md={4}>
                      <Chip
                        icon={<CropIcon />}
                        label={`${crops[cropSelected]} ${variantsOfCrop[cropSelected]}`}
                        className={classes.infoChip}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Chip
                        icon={<PhenologicalStageIcon />}
                        label={`${phenoStages[cropSelected]}`}
                        className={classes.infoChip}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Chip
                        icon={<DateRange />}
                        label={weekAndDay}
                        className={classes.infoChip}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Chip
                        icon={<CultivationEnvironmentIcon />}
                        label={`Entorno: ${placeOfCrops[cropSelected]}`}
                        className={classes.infoChip}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Chip
                        icon={placeOfCrops[cropSelected] === "Exterior" ? <SoilTypeIcon /> : <HydroponicSystemTypeIcon width={52} height={52} />}
                        label={`${placeOfCrops[cropSelected] === "Exterior" ? "Suelo" : "Sistema"}: ${envCrop}`}
                        className={classes.infoChip}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Sección de imágenes de cámaras */}
                {/* <Box style={{ marginTop: 24, textAlign: 'center' }}>
                  <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                    <span role="img" aria-label="camera">📷</span> Visualiza imágenes capturadas por las cámaras de monitoreo
                  </Typography>
                  <CameraImages selectedCropName={crops[cropSelected]} />
                </Box> */}
              </CardContent>
            </Card>
          </Slide>

          {/* Sección de sensores */}
          <Slide direction="up" in timeout={1200}>
            <Card className={classes.sensorCard}>
              <CardContent>
                <Grid container alignItems="center" justifyContent="space-between">
                  <Grid item>
                    <Typography variant="h6" gutterBottom>
                      Configuración de Sensores
                    </Typography>
                  </Grid>
                </Grid>

                <Box>
                  <Box style={{ marginTop: 16 }}>
                    <SelectSensors
                      indexOfCrop={cropSelected}
                      username={usuario.username}
                      confirmSync={() => setSynchronized(true)}
                      loadingChat={loadingAnalysis}
                    />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Slide>

          {/* Selector de modo de respuesta */}
          <Box style={{ marginTop: 8 }}>
            <Grid container justifyContent="flex-start" alignItems="flex-start">
              <label style={{ marginTop: 12 }}>Modo de respuesta:</label>
              <FormControl variant="outlined" className={classes.formControl}>
                <Select
                  value={typeOfResponse}
                  onChange={(event) => setTypeOfResponse(event.target.value)}
                  displayEmpty
                  labelWidth={0}
                >
                  <MenuItem value={"PyT"}>Lenguaje profesional y técnico</MenuItem>
                  <MenuItem value={"CyA"}>Lenguaje común y accesible</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Box>

          {/* Imagen (opcional) para análisis inicial */}
          {/* <Box style={{ marginTop: 8 }}>
            <Grid container justifyContent="flex-start" alignItems="flex-start">
              <Typography>Imagen (opcional):</Typography>
            </Grid>
            <Grid container justifyContent="center" alignItems="center">
              <input
                accept="image/*"
                className={classes.input}
                id="firstImage"
                type="file"
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    const img = e.target.files[0];
                    setImage(img);
                    setImageUrl(URL.createObjectURL(img));
                    setImageFlag(true);
                  } else {
                    setImage(null);
                  }
                }}
                disabled={isNewChat === 'no'}
              />
              <label htmlFor="firstImage">
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  disabled={isNewChat === 'no'}
                  startIcon={<PhotoCameraOutlined />}
                >
                  Subir Imagen
                </Button>
              </label>
            </Grid>
            <Grid container justifyContent="center" alignItems="center">
              {imageUrl && (
                <Box m={1} style={{ position: 'relative', display: 'inline-block' }}>
                  <img src={imageUrl} alt="Imagen seleccionada" height="100" />
                  <IconButton
                    onClick={() => {
                      setImage(null);
                      setImageUrl('');
                      setImageFlag(false);
                    }}
                    color="secondary"
                    style={{ position: 'absolute', right: -14, top: -15, backgroundColor: 'transparent', margin: 0, padding: '0px' }}
                    disabled={isNewChat === 'no'}
                  >
                    <CancelOutlined />
                  </IconButton>
                </Box>
              )}
            </Grid>
          </Box> */}

          {/* Botón principal se mueve al pie del chat */}

          {/* Chatbot */}
          <Slide direction="up" in timeout={1600}>
            <Paper className={classes.chatContainer}>
              {/* Header del chat */}
              <Box className={classes.chatHeader}>
                <Avatar style={{ marginRight: 12 }}>
                  <img style={{width: '100%'}} src={japyIcon} alt="Japy Icon" />
                </Avatar>
                <Typography variant="h6">
                  Chat con Japy
                </Typography>
              </Box>

              {/* Mensajes */}
              <Box className={classes.chatMessages}>
                {messages.map((message, index) => (
                  <Fade in key={index} timeout={500} style={{ transitionDelay: `${index * 100}ms` }}>
                    <Box
                      className={
                        message.type === 'bot' ? classes.messageBot : classes.messageUser
                      }
                    >
                      {message.type === 'bot' ? (
                        <ReactMarkdown remarkPlugins={[remarkGfm]} components={{
                          p({ node, children }) {
                            return (
                              <p style={{ whiteSpace: 'normal', overflowWrap: 'break-word', wordBreak: 'break-word', margin: 0 }}>
                                {children}
                              </p>
                            );
                          },
                        }}>
                          {message.content}
                        </ReactMarkdown>
                      ) : (
                        <Typography variant="body1">
                          {message.content}
                        </Typography>
                      )}
                      <Typography
                        variant="caption"
                        style={{
                          opacity: 0.7,
                          marginTop: 4,
                          display: 'block',
                          fontSize: '0.75rem',
                        }}
                      >
                        {message.timestamp.toLocaleTimeString()}
                      </Typography>
                    </Box>
                  </Fade>
                ))}
              </Box>

              {/* Input del chat */}
              <Box className={classes.chatInput}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder={isNewChat === 'yes' ? 'Opcional: agrega un mensaje antes del primer análisis...' : 'Escribe tu mensaje aquí...'}
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault();
                      handlePrimaryAction();
                    }
                  }}
                  className={classes.inputField}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <input
                          accept="image/*"
                          className={classes.input_IC}
                          id="icon-button-file"
                          type="file"
                          onChange={(event) => {
                            if (event.target.files && event.target.files[0]) {
                              const img = event.target.files[0];
                              setImage(img);
                              const reader = new FileReader();
                              reader.onload = (e2) => setSecondImageUrl(e2.target.result);
                              reader.readAsDataURL(img);
                              setImageFlag(true);
                            } else {
                              setImage(null);
                            }
                          }}
                          disabled={loadingAnalysis}
                        />
                        <label htmlFor="icon-button-file">
                          <IconButton color="primary" aria-label="upload new picture" component="span" disabled={loadingAnalysis}>
                            <ImageSearchOutlined />
                          </IconButton>
                        </label>
                        {secondImageUrl && (
                          <Box style={{ position: 'relative', display: 'inline-flex', maxWidth: '100%' }}>
                            <img src={secondImageUrl} alt="Selected" style={{ maxHeight: '50px', width: 'auto', maxWidth: '100%' }} />
                            <IconButton
                              onClick={() => {
                                setImage(null);
                                setSecondImageUrl('');
                                setImageFlag(false);
                              }}
                              color="secondary"
                              disabled={loadingAnalysis}
                              style={{ position: 'absolute', right: -14, top: -10, backgroundColor: 'transparent', margin: 0, marginRight: 8, padding: '0px' }}
                            >
                              <CancelOutlined />
                            </IconButton>
                          </Box>
                        )}
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <Button
                          variant="contained"
                          size="medium"
                          className={classes.analyzeButton}
                          onClick={handlePrimaryAction}
                          disabled={loadingAnalysis || (isNewChat === 'yes' && !synchronized)}
                        >
                          {loadingAnalysis ? (isNewChat === 'yes' ? 'Analizando...' : 'Enviando...') : (isNewChat === 'yes' ? 'Analizar Cultivo' : 'Enviar')}
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Paper>
          </Slide>

          {/* Historial de chats */}
          <Box style={{ marginTop: 16 }}>
            <HistoricalChatsPanel
              username={usuario.username}
              onContinueChat={(chatTitle) => {
                continueChat(chatTitle);  
              }}
              onDownloadError={(msg) => setMessages(prev => ([...prev, { type: 'bot', content: msg, timestamp: new Date() }]))}
            />
          </Box>
        </Box>
      </Box>
  );
};

